import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatRadioModule} from '@angular/material/radio';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSelectModule, MatSelect} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { TrainingselectComponent } from '@src/app/components/trainingselect/trainingselect.component';
import { BookselectComponent } from './components/bookselect/bookselect.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatTableModule} from '@angular/material/table';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSortModule} from '@angular/material/sort';

import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@src/app/app-routing.module';
import { AppComponent } from '@src/app/app.component';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HomeComponent } from '@src/app/home/home.component';
import { SummaryComponent } from '@src/app/components/summary/summary.component';
import { ExamComponent } from '@src/app/components/exam/exam.component';
import { GatetypeComponent } from '@src/app/components/gatetype/gatetype.component';
import { HeaderComponent } from '@src/app/components/header/header.component';
import { UserdataComponent } from '@src/app/components/userdata/userdata.component';
// import { UserdataComponent } from '@src/app/components/UserdataComponent/userdata.component';
import { UserdataformComponent } from '@src/app/components/userdataform/userdataform.component';
import { UserdataformComponentFr } from '@src/app/components/UserdataformFr/userdataformfr.component';
import { UserdataformComponentKbw } from '@src/app/components/userdataformkbw/userdataformkbw.component';
import { VideoTrainingComponent } from '@src/app/components/videotraining/videotraining.component';
import { ReportComponent } from '@src/app/components/report/report.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { AuthGuard } from '@src/app/services/authGuard.service';
import { ErrorInterceptor } from '@src/app/helpers/error.interceptor';
import { JwtInterceptor } from '@src/app/helpers/jwt.interceptor';
import { UserService } from '@src/app/services/userService.service';
import { JwtService } from '@src/app/services/jwt.service';
import { ReportService } from '@src/app/services/reportService.service';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '@src/environments/environment';
import { TrainingFilesComponent } from '@src/app/components/trainingfiles/trainingfiles.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import {YouTubePlayerModule} from '@angular/youtube-player';
import { PopupConfirmComponent } from '@src/app/components/popup-confirm/popup-confirm.component';
import { PopupInfoComponent } from '@src/app/components/popup-info/popup-info.component';
import { CriteriaformComponent } from '@src/app/components/criteriaform/criteriaform.component';
//import { RecaptchaModule } from 'ng-recaptcha';
//import { RecaptchaCommonModule } from 'ng-recaptcha/recaptcha/recaptcha-common.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RecaptchaFormsModule } from 'ng-recaptcha';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { LoginComponent } from '@src/app/components/login/login.component';
import { YmComponent } from '@src/app/components/ym/ym.component';
import { CommonModule } from '@angular/common';
import { BaseComponent } from './components/baseComponent/base.component';
import { ErrorHandlerService } from './services/errorHandler.service';
import { KBWMonitoringService } from './services/logging.service';
import {MatTabsModule} from '@angular/material/tabs';

import { SharedModule } from '../app/shared.module';


// import { NgSelectModule } from '@ng-select/ng-select';
// import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
// import {Ng2TelInputModule} from 'ng2-tel-input';


// import { } from '@angular/'
 import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
// import {SingleMediaPlayer} from './single-media-player';
// import { TextMaskModule } from 'angular2-text-mask';
import { provideNgxMask } from 'ngx-mask';


@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        SummaryComponent,
        ExamComponent,
        HeaderComponent,
        UserdataComponent,
        UserdataformComponent,
        UserdataformComponentFr,
        UserdataformComponentKbw,
        TrainingselectComponent,
        TrainingFilesComponent,
        VideoTrainingComponent,
        ReportComponent,
        PopupConfirmComponent,
        PopupInfoComponent,
        CriteriaformComponent,
        LoginComponent,
        YmComponent,
        GatetypeComponent,
        BookselectComponent,
        BaseComponent
    ],
    bootstrap: [AppComponent], imports: [
        // CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        // NgSelectModule,
        // NgxIntlTelInputModule,
        // TooltipModule.forRoot(),
        TranslateModule.forRoot({
            defaultLanguage: 'en-GB',
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            }
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter: function tokenGetter() {
                    return sessionStorage.getItem('token');
                },
                allowedDomains: [`${environment.apiDomain}`],
                disallowedRoutes: [
                    `//${environment.apiDomain}/user/getTrainingTypes/`,
                    `//${environment.apiDomain}/user/GetUserData/`,
                    `//${environment.apiDomain}/user/Login/`
                ],
                //throwNoTokenError: true
            }
        }),
        // MATERIAL COMPONENTS
        MatStepperModule,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatButtonModule,
        MatToolbarModule,
        MatRadioModule,
        MatDividerModule,
        MatProgressBarModule,
        MatMenuModule,
        MatIconModule,
        MatListModule,
        MatSidenavModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonToggleModule,
        MatGridListModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatDialogModule,
        MatSnackBarModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatNativeDateModule,
        MatTabsModule,
        // MATERIAL COMPONENTS
        NgxExtendedPdfViewerModule,
        YouTubePlayerModule,
        RecaptchaFormsModule,
        RecaptchaV3Module,
        // RecaptchaModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule
        // TextMaskModule
    ], providers: [
        KBWMonitoringService,
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        // {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LeZkrUZAAAAANaBuP0xrHuVjEorKkb_cTfG_6CC' },
        UserService,
        provideNgxMask({
            showMaskTyped: true,
            dropSpecialCharacters: true
        })
        //AuthGuard,
        ,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
